<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>

    <b-modal size="lg"
             :hide-footer="true"
             id="modal-delivery-address" title="New Address">
      <b-form-group label="Land" class="required">
        <b-form-select
            v-model="formDeliveryAddress.country"
            :options="countries"
            value-field="city_id"
            text-field="city_name"
        ></b-form-select>
      </b-form-group>

      <b-form-group label="Gender" class="required">
        <b-form-select v-model="formDeliveryAddress.gender" class="mb-3">
          <b-form-select-option value="male">Herr</b-form-select-option>
          <b-form-select-option value="female">Frau</b-form-select-option>
        </b-form-select>
      </b-form-group>


      <b-form-group label="Vorname" class="required">
        <b-input placeholder="" v-model="formDeliveryAddress.first_name"></b-input>
      </b-form-group>
      <b-form-group label="Nachname" class="required">
        <b-input v-model="formDeliveryAddress.last_name"></b-input>
      </b-form-group>
      <b-form-group label="Straße und Hausnummer" class="required">
        <b-input v-model="formDeliveryAddress.st_house_number"></b-input>
      </b-form-group>
      <b-form-group label="Adresszusatz (z.B. Firma/Stiege/Türnummer max 10 Zeichen)" class="required">
        <b-input v-model="formDeliveryAddress.additional"></b-input>
      </b-form-group>
      <b-form-group label="Plz" class="required">
        <b-input v-model="formDeliveryAddress.post_code"></b-input>
      </b-form-group>
      <b-form-group label="Stadt" class="required">
        <b-input v-model="formDeliveryAddress.city_name"></b-input>
      </b-form-group>
      <b-form-group label=" ">
        <b-button variant="success" @click="storeDeliveryAddress">SAVE</b-button>
      </b-form-group>
    </b-modal>
    <!--modal store delivery address-->

    <template v-if="isSuccess">
      <b-alert show variant="success">Bestellung erfolgreich registriert</b-alert>
      <b-link :to="{name:'OrdersPrint',params:{'orderid':orderId}}" class="btn btn-outline-danger mr-1">
        {{ $t('printTitle') }}
      </b-link>

      <template v-if="!isAnonymous">
        <b-link :to="{name:'OrderDetails',params:{'orderid':orderId}}" class="btn btn-success mr-1">
          {{ $t('details') }}
        </b-link>
      </template>


    </template>

    <template v-else>
      <navbar>
        <template v-slot:navbarname>
          <b-button @click="cancelOrder" class="btn-round" variant="primary">back</b-button>
        </template>
      </navbar>


      <b-row>
        <b-col cols="12" md="8">
          <v-select
              class="mb-4"
              placeholder="select user"
              :reduce="username => username.id"
              label="username"
              v-model="userId"
              @input="getUserAddress"
              :options="users">
            <template #option="{ username, userSelect }">
              <h5 style="margin: 0">{{ username }}</h5>
              <em>{{ userSelect.email }}</em>
            </template>
          </v-select>

          <b-card>
            <b-form-group v-if="!isAnonymous" label="Gender" class="required">
              <b-form-select v-model="form.order_gender" class="mb-3">
                <b-form-select-option value="male">Herr</b-form-select-option>
                <b-form-select-option value="female">Frau</b-form-select-option>
              </b-form-select>
            </b-form-group>
            <b-form-group
                :state="!validation.hasError('order_fname')"
                :invalid-feedback="validation.errorTitle('order_fname')"
                label="Vorname " class="required">
              <b-input v-model="form.order_fname"></b-input>
            </b-form-group>
            <b-form-group
                :state="!validation.hasError('order_lname')"
                :invalid-feedback="validation.errorTitle('order_lname')"
                label="Nachname  " class="required">
              <b-input v-model="form.order_lname"></b-input>
            </b-form-group>
            <b-form-group label="Firma  ">
              <b-input v-model="form.order_company_name"></b-input>
            </b-form-group>
            <b-form-group
                :state="!validation.hasError('order_country_id')"
                :invalid-feedback="validation.errorTitle('order_country_id')"
                label="Land" class="required">
              <b-form-select
                  v-model="form.order_country_id"
                  :options="countries"
                  value-field="city_id"
                  text-field="city_name"
              ></b-form-select>
            </b-form-group>
            <b-form-group
                :state="!validation.hasError('order_address_street')"
                :invalid-feedback="validation.errorTitle('order_address_street')"
                label="Straße" class="required">
              <b-input v-model="form.order_address_street"></b-input>
            </b-form-group>
            <b-form-group
                :state="!validation.hasError('order_address_aparteman')"
                :invalid-feedback="validation.errorTitle('order_address_aparteman')"
                label="Hausnummer/Stiege/Tür" class="required">
              <b-input v-model="form.order_address_aparteman"></b-input>
            </b-form-group>
            <b-form-group
                :state="!validation.hasError('order_city')"
                :invalid-feedback="validation.errorTitle('order_city')"
                label="Ort / Stadt" class="required">
              <b-input v-model="form.order_city"></b-input>
            </b-form-group>
            <b-form-group
                :state="!validation.hasError('order_postcode')"
                :invalid-feedback="validation.errorTitle('order_postcode')"
                label="Postleitzahl " class="required">
              <b-input v-model="form.order_postcode"></b-input>
            </b-form-group>
            <b-form-group label="Telefon " class="">
              <b-input v-model="form.order_phone"></b-input>
            </b-form-group>
          </b-card>
          <!--form inputs-->


          <template v-if="!isAnonymous">
            <b-form-checkbox v-model="form.deliveryAddressStatus">
                            <span style="font-size: 22px"
                                  class="font-weight-bold">Do you have a delivery address?</span>
            </b-form-checkbox>
          </template>


          <b-card class="delivery-address-wrapper"
                  v-if="form.deliveryAddressStatus && !isAnonymous"
                  title="Delivery Address">
            <b-button
                v-b-modal.modal-delivery-address
                variant="primary" size="sm">+ new address
            </b-button>

            <b-input v-if="addressDelivery.length > 0"
                     v-model="searchInput"
                     class="mt-4" placeholder="search..."></b-input>

            <b-row class="" v-if="addressDelivery.length > 0">

              <b-col col="12" md="4" v-for="(deliveryAddressItem,indexDeliveryAddress) in searchAddress"
                     :key="indexDeliveryAddress">
                <b-card
                    class="shadow-none border">
                  <p>{{ deliveryAddressItem.gender }} {{ deliveryAddressItem.first_name }}
                    {{ deliveryAddressItem.last_name }}</p>
                  <p>{{ deliveryAddressItem.street }} {{ deliveryAddressItem.additional }}</p>
                  <p>{{ deliveryAddressItem.post_code }} {{ deliveryAddressItem.city }}</p>
                  <p>{{ deliveryAddressItem.country }}</p>


                  <div class="mt-3">
                    <b-form-radio v-model="form.deliveryAddressId" name="deliveryAddress"
                                  :value="deliveryAddressItem.id">select
                    </b-form-radio>

                    <a
                        @click.prevent="deleteDeliveryAddress(deliveryAddressItem.id)"
                        href="#" class="text-danger">delete</a>
                  </div>
                </b-card>
              </b-col>

            </b-row>

          </b-card>

        </b-col>
        <!--Form-->


        <b-col cols="12" md="4">

          <div class="sticky-top" style="top: 16px">
            <b-card>
              <b-form-radio-group
                  id="payments"
                  v-model="paymentType"
                  :options="payments"
                  name="radio-payments"
                  stacked
              ></b-form-radio-group>


            </b-card>

            <b-button @click="storeOrder" block variant="success">Jetzt bezahlen</b-button>
          </div>


        </b-col>
        <!--Payment-->
      </b-row>
    </template>


  </div>
</template>

<script>
import Http from '../../Services/HttpService/HttpService'
import Notificaion from '../../Services/Notification/Nottification'
import Validation from '../../Services/Validation/Validation'

import Navbar from "../Partials/Navbar";
import {EventBus} from "../../Services/Eventbus/event-bus";
import 'vue-select/dist/vue-select.css';

export default {
  name: "FormOrder",
  components: {Navbar},
  props: {
    productSelected: {
      type: Array,
      default: null
    },
    users: {
      type: Array,
      default: null
    },
    coupon: {
      type: Object,
      default: null
    },
    transportType: {
      type: Number,
      default: null
    },
    totalPrice: {
      type: Number,
      default: null
    },
    subTotal: {
      type: Number,
      default: null
    },
    totalTax: {
      type: Number,
      default: null
    },
    totalOffer: {
      type: Number,
      default: null
    },
    totalDifference: {
      type: Number,
      default: null
    },
    totalDiscount: {
      type: Number,
      default: null
    },
    totalPriceWithTransport: {
      type: Number,
      default: null
    },
    userIdProb: {
      type: Number,
      default: null
    },
    isAnonymous: {
      type: Boolean,
      default: false
    },

  },
  data() {
    return {
      validation: new Validation(),
      userId: 0,
      countries: [],
      payments: [],
      paymentType: null,
      searchInput: null,
      isSuccess: false,
      orderId: 0,
      form: {
        order_country_id: null,
        order_gender: null,
        order_fname: null,
        order_lname: null,
        order_company_name: null,
        order_address_street: null,
        order_address_aparteman: null,
        order_postcode: null,
        order_city: null,
        order_phone: null,
        deliveryAddressId: 0,
        deliveryAddressStatus: true
      },
      formDeliveryAddress: {
        user: 0,
        country: null,
        gender: 'male',
        first_name: null,
        last_name: null,
        st_house_number: null,
        additional: null,
        post_code: null,
        city_name: null,
      },
      addressDelivery: [],
    }
  },
  computed: {
    searchAddress() {
      if (this.searchInput === null) {
        return this.addressDelivery;
      }

      return this.addressDelivery.filter(item => {
        return item.first_name.toLowerCase().match(this.searchInput.toLowerCase()) ||
            item.last_name.toLowerCase().match(this.searchInput.toLowerCase()) ||
            item.additional.toLowerCase().match(this.searchInput.toLowerCase()) ||
            item.street.toLowerCase().match(this.searchInput.toLowerCase()) ||
            item.city.toLowerCase().match(this.searchInput.toLowerCase()) ||
            item.post_code.toLowerCase().match(this.searchInput.toLowerCase())
      })
    },
  },
  methods: {
    cancelOrder() {
      EventBus.$emit('processOrder', 'yes');
    },
    storeOrder() {
      if (!this.isAnonymous && this.form.order_gender === null){
        Notificaion.error("Please select gender");
        return;
      }
      if (this.paymentType === null) {
        Notificaion.error("Please select payment type");
        return;
      }

      if (this.form.deliveryAddressStatus) {
        if (!this.isAnonymous && this.form.deliveryAddressId === 0) {
          Notificaion.error("Please select delivery address");
          return;
        }
      }

      this.$Progress.start();
      Http.post(Http.apiurlV2() + 'order/factor/store', {
        coupon: this.coupon,
        paymentType: this.paymentType,
        transportType: this.transportType,
        totalPrice: this.totalPrice,
        totalPriceWithTransport: this.totalPriceWithTransport,
        subTotal: this.subTotal,
        totalOffer: this.totalOffer,
        totalTax: this.totalTax,
        totalDifference: this.totalDifference,
        totalDiscount: this.totalDiscount,
        userId: this.userId,
        order: this.form,
        products: this.productSelected,
        isAnonymous: this.isAnonymous,
        deliveryAddressStatus: this.form.deliveryAddressStatus,
      })
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.created()) {
              Notificaion.success(response.data.message);
              this.orderId = response.data.data.order_id;
              this.isSuccess = true;
            } else {
              Notificaion.error(response.data.message);
              this.validation.store(response.data.data);
            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    },
    resetFormDeliveryAddressValues() {
      this.formDeliveryAddress.country = null;
      this.formDeliveryAddress.city_name = null;
      this.formDeliveryAddress.post_code = null;
      this.formDeliveryAddress.additional = null;
      this.formDeliveryAddress.last_name = null;
      this.formDeliveryAddress.first_name = null;
      this.formDeliveryAddress.st_house_number = null;
    },
    storeDeliveryAddress() {
      if (this.formDeliveryAddress.country === null ||
          this.formDeliveryAddress.city_name === null ||
          this.formDeliveryAddress.post_code === null ||
          this.formDeliveryAddress.additional === null ||
          this.formDeliveryAddress.last_name === null ||
          this.formDeliveryAddress.st_house_number === null
      ) {
        Notificaion.error("Please fill in the required fields");
        return;
      }

      this.formDeliveryAddress.user = this.userId;
      this.$Progress.start();
      Http.post(Http.apiurlV2() + 'order/factor/store/deliveryaddress', this.formDeliveryAddress)
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.created()) {
              Notificaion.success(response.data.message);
              this.getUserAddressDelivery(); //get user address
              this.resetFormDeliveryAddressValues(); // reset form
              this.$bvModal.hide('modal-delivery-address');
            } else {
              Notificaion.error(response.data.message);
            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    },
    getCountries() {
      this.$Progress.start();
      Http.get(Http.apiurlV2() + 'order/factor/countries')
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.ok()) {
              this.countries = response.data.data;

              this.getPaymentsOptions();
            }
          })
          .catch(error => {
            this.$Progress.finish();
          })

    },
    getUserAddress() {
      this.$Progress.start();
      Http.post(Http.apiurlV2() + 'order/factor/user/data', {
        type: 'address',
        userId: this.userId
      })
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.ok()) {
              this.addressDelivery = response.data.data.addressOrderDelivery;
              let myData = response.data.data.addressOrder;
              this.form.order_country_id = myData.address_country_id;
              this.form.order_fname = myData.address_firstname;
              this.form.order_lname = myData.address_lastname;


              if (this.transportType !== 8) {
                this.form.order_address_street = myData.address_st_house_number;
                this.form.order_address_aparteman = myData.address_additional;
                this.form.order_postcode = myData.address_post_code;
                this.form.order_city = myData.address_city_name;
              }


            }
          })
          .catch(error => {
            this.$Progress.finish();
          })

    },
    getUserAddressDelivery() {
      this.$Progress.start();
      Http.post(Http.apiurlV2() + 'order/factor/user/data', {
        type: 'address',
        userId: this.userId
      })
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.ok()) {
              this.addressDelivery = response.data.data.addressOrderDelivery;
            }
          })
          .catch(error => {
            this.$Progress.finish();
          })

    },
    getPaymentsOptions() {
      this.$Progress.start();
      Http.get(Http.apiurlV2() + 'order/factor/payments/options')
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.ok()) {
              this.payments = response.data.data;
            }
          })
          .catch(error => {
            this.$Progress.finish();
          })

    },
    deleteDeliveryAddress(myId) {
      if (confirm(this.$t('alertText'))) {
        this.$Progress.start();
        Http.get(Http.apiurlV2() + 'order/factor/deliveryaddress/delete/' + myId)
            .then(response => {
              this.$Progress.finish();
              if (response.data.status_code === Http.ok()) {
                Notificaion.success(response.data.message);
                this.getUserAddress();
              }
            })
            .catch(error => {
              this.$Progress.finish();
            })
      }


    },
    checkAddressCkickAndCollect() {
      if (this.transportType === 8) {
        this.form.order_address_street = "Kramergasse";
        this.form.order_address_aparteman = "3 / 4.Stock / Top 15";
        this.form.order_postcode = "1010";
        this.form.order_city = "Wien";
      }

    }
  },
  mounted() {
    this.userId = this.userIdProb;
    this.getUserAddress();
    this.getCountries();


  },
  created() {
    this.checkAddressCkickAndCollect();
  }
}
</script>

<style scoped>
.shadow-none {
  box-shadow: none !important;
}

.delivery-address-wrapper .card {
  transition: background-color ease-in-out 150ms;
}

.delivery-address-wrapper .card:hover {
  background-color: #f1f1f1;
}
</style>